// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myPoint {
  display: flex;
  justify-content: space-around;
  align-items: center;
  align-self: stretch;
  padding: 0;
  margin: 0 auto 10px;
}
.myPoint li {
  display: flex;
  padding: 4px;
  color: var(--Supervin-colors-Bourgogne, #5C0A31);
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  cursor: pointer;
}
.myPoint .hide-btn {
  visibility: hidden;
  pointer-events: none;
  opacity: 0;
  cursor: default;
}
.myPoint::ng-deep app-circle-icon svg {
  fill: rgba(92, 10, 49, 0.35);
}
.myPoint::ng-deep .active app-circle-icon svg {
  fill: var(--Supervin-colors-Bourgogne, #5C0A31);
}`, "",{"version":3,"sources":["webpack://./src/app/content/layout/components/general/carousel-point/carousel-point.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,YAAA;EACA,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AACJ;AAEE;EACE,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,eAAA;AAAJ;AAII;EACE,4BAAA;AAFN;AAKI;EACE,+CAAA;AAHN","sourcesContent":[".myPoint {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  align-self: stretch;\n  padding: 0;\n  margin: 0 auto 10px;\n\n  li {\n    display: flex;\n    padding: 4px;\n    color: var(--Supervin-colors-Bourgogne, #5C0A31);\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 25px;\n    cursor: pointer;\n  }\n\n  .hide-btn {\n    visibility: hidden;\n    pointer-events: none;\n    opacity: 0;\n    cursor: default;\n  }\n\n  &::ng-deep {\n    app-circle-icon svg {\n      fill: rgba(92, 10, 49, 0.35);\n    }\n\n    .active app-circle-icon svg {\n      fill: var(--Supervin-colors-Bourgogne, #5C0A31);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
